/* import __COLOCATED_TEMPLATE__ from './launcher.hbs'; */
/* RESPONSIBLE TEAM: team-messenger */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';

export default class Launcher extends Component {
  @service MessengerSettingsService;
}
